import Icons from "assets";

export const BUTTON_ALIGNMENT_OPTIONS = [
  {
    label: (
      <div className="py-1 flex justify-center">
        <Icons.ButtonAlignLeft aria-label="Align button left" />
      </div>
    ),
    value: "left",
  },
  {
    label: (
      <div className="py-1 flex justify-center">
        <Icons.ButtonAlignCenter aria-label="Align button center" />
      </div>
    ),
    value: "center",
  },
  {
    label: (
      <div className="py-1 flex justify-center">
        <Icons.ButtonAlignRight aria-label="Align button right" />
      </div>
    ),
    value: "right",
  },
];
